import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';

export type SPViewHeaderLocNames =
	| 'SPViewHeaderTitleSiteName'
	| 'SPViewHeaderMenuItemHelp';

export const spViewHeaderLocs: LocDefs<SPViewHeaderLocNames> = {
	SPViewHeaderTitleSiteName: {
		defaultValue: 'CM Connect',
		description: 'The name of the website in the middle of the header.',
		displayPath: 'System|Sidenav|Site Name',
		displayType: 'Title',
		legacyName: 'Core/_View.Sidenav.Title.SiteName',
		shared: false,
		htmlAllowed: false,
		feature: HubFeature.Core,
		portal: 'SP',
	},
	SPViewHeaderMenuItemHelp: {
		defaultValue: 'Help',
		description: 'Help menu item in the user profile dropdown.',
		displayPath: 'System|Sidenav|Menu Item Help',
		displayType: 'Title',
		shared: false,
		htmlAllowed: false,
		feature: HubFeature.Core,
		portal: 'SP',
	},
};

export type SPViewHeaderLocType = LocMap<SPViewHeaderLocNames>;
export const spViewHeaderLocKeys = 	MapLocKeys<SPViewHeaderLocNames>(spViewHeaderLocs);
